import React from "react";
import { Box } from "@mui/material";

/**
 * Badge — soft-filled semantic pill for statuses and tags.
 *
 * Props:
 *   variant: "success" | "warning" | "error" | "info" | "neutral" | "brand"
 *   icon:    optional lucide-react component (rendered left, 12px)
 */

const VARIANTS = {
  success: { bg: "#ecfdf5", fg: "#047857" }, // emerald-50 / emerald-700
  warning: { bg: "#fffbeb", fg: "#b45309" }, // amber-50 / amber-700
  error: { bg: "#fef2f2", fg: "#b91c1c" }, // red-50 / red-700
  info: { bg: "#eff6ff", fg: "#1d4ed8" }, // blue-50 / blue-700
  neutral: { bg: "#f1f5f9", fg: "#334155" }, // slate-100 / slate-700
  brand: { bg: "#fff7ed", fg: "#c2410c" }, // orange-50 / orange-700
};

function Badge({ variant = "neutral", icon: Icon, children, sx, ...rest }) {
  const colors = VARIANTS[variant] || VARIANTS.neutral;
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        px: "8px",
        py: "2px",
        borderRadius: "6px",
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1.4,
        whiteSpace: "nowrap",
        backgroundColor: colors.bg,
        color: colors.fg,
        ...(sx || {}),
      }}
      {...rest}
    >
      {Icon && <Icon size={12} strokeWidth={2.25} />}
      {children}
    </Box>
  );
}

export default Badge;
